module.exports = __webpack_public_path__ + "static/media/wheelchair.c4bb6eae.svg";